// variables
import { StyledSvgIcon } from 'variables';

// libraries
import styled from 'styled-components';

export const StyledLayerIcon = styled.svg`
  ${StyledSvgIcon}
`;
